<div *ngIf="hasDescription; else noDescription" class="description">

    <!-- START Left description -->
    <div class="flex-3">
        <section class="sep-rtl-in introduction-section">
            <fa-icon [icon]="iconQuoteLeft" class="quote-icon"></fa-icon>
            <!-- #29663 keep two variants for retrocompatibility and front merging GPP (template full) with SQA (template list)-->
            <p *ngFor="let textLine of description.introduction?.description?.textLineArray" class="introduction" [innerHTML]="textLine|htmlize|safeHtml"></p>
            <p *ngFor="let textLine of description.introduction?.textLines" class="introduction" [innerHTML]="textLine|htmlize|safeHtml"></p>
        </section>

        <section>
            <ng-container *ngFor="let detail of descriptions">
                <article class="sep-rtl-in">
                    <h1 class="article-title">{{ detail.title }}</h1>
                    <p *ngFor="let textLine of detail.textLines || detail.textLine" [innerHTML]="textLine|htmlize|safeHtml"></p>
                </article>
            </ng-container>
        </section>

        <section #keywordsSection class="sep-rtl-in keywords-section" *ngIf="description.keywords?.length||description.keywordArray?.length">
            <h1 class="article-title" id="keywords">{{ wordingKeyWords }}</h1>
            <ul>
                <li *ngFor="let keyword of (description.keywords||description.keywordArray)" class="keyword">
                    {{ keyword?.name && ( keyword.name?.languageCode | isNullOrEquals : description.languageCode ) ? keyword.name.value : keyword.xCode }}
                </li>

                <ng-container *ngIf="roomKeywords">
                    <li *ngFor="let keyword of roomKeywords" class="keyword">
                        {{ keyword?.name && (keyword?.name.languageCode | isNullOrEquals : description.languageCode) ? keyword?.name.value : keyword?.xCode}}
                    </li>
                </ng-container>
            </ul>
        </section>

        <footer *ngIf="description.credit" class="sep-rtl-in">
            <em>
                © {{description.credit.text}}
            </em>
        </footer>
    </div>
    <!-- END Left description -->

    <!-- START right description -->
    <aside class="flex-1 complementary">
        <ng-container *ngIf="mainVignette">
            <a [href]="mainImage.url" target="_blank">
                <img class="sep-bottom"
                     [attr.src]="mainVignette.url"
                     [attr.alt]="description.introduction.title"
                     width="100%">
            </a>
        </ng-container>

        <div *ngIf="description.rating" class="sep-bottom">
            <div *ngIf="description.rating.traveller" class="sep-bottom">
                <h3>{{ wordingTravellerRating }}</h3>
                <rating [rating]="description.rating.traveller.value||description.rating.traveller"></rating>
            </div>

            <div *ngIf="description.rating.standard||description.rating.standardisationBody">
                <h3>{{ wordingStandardRating }}</h3>
                <rating [rating]="description.rating.standard?.value||description.rating.standardisationBody"></rating>
            </div>
        </div>

        <div class="sep-bottom sep-top">
            <a class="link-color"
               *ngIf="description.keyword?.length"
               (click)="scrollToKeywordsSection()">
                {{ wordingSeeAllKeywords }}
            </a>

            <div class="sep-top">
        <span *ngIf="description.name">
            {{ description.name.text }}<br>
        </span>
            </div>
        </div>
    </aside>
    <!-- START right description -->
</div>

<ng-template #noDescription>
    <div class="description">
        <em>{{ wordingNoDescription }}</em>
    </div>
</ng-template>
